import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import {
  TheatricalSearchCoords,
  TheatricalVenuesListQuery,
  TheatricalVenuesListQueryVariables,
} from '@/types/codegen-federation'

interface Coordinates extends TheatricalSearchCoords {
  latitude: number
  longitude: number
}

interface UseVenueListProps {
  coordinates?: Coordinates
}

const GET_THEATRICAL_VENUES = gql`
  query theatricalVenuesList($input: TheatricalVenuesInput!) {
    theatricalVenues(input: $input) {
      venues {
        id
        name
        providerId
        isPresaleCompatible
        presaleGoal {
          ticketsSold
          nextMilestone
        }
        distance
        vendorLogo {
          cloudinaryPath
        }
        phone
        addressText
        address {
          line
          city
          countryCode
          zipCode
        }
      }
      userLocation {
        city
        countryCode
        state
        zipCode
      }
    }
  }
`

export function useVenueList({ coordinates }: UseVenueListProps) {
  const { data, loading, error } = useQuery<TheatricalVenuesListQuery, TheatricalVenuesListQueryVariables>(
    GET_THEATRICAL_VENUES,
    {
      variables: {
        input: {
          coords: coordinates,
          distanceMeters: 100000,
        },
      },
    },
  )
  return {
    venues: data?.theatricalVenues?.venues || [],
    userLocation: data?.theatricalVenues?.userLocation,
    loading,
    error,
  }
}
